import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";

const testimonialsData = [
  {
    id: 1,
    image: require("../assets/images/dilshod.png"),
    testimonieText:
      "Rahmat oyoq kiyim zorakan oka dostavkaga ummuman gap yo, Ochki un alohoda rahmat",
    avatar: require("../assets/images/dilshodbek.jpg"),
    testimonieName: "Dilshodbek",
    indentity: "Mijoz",
    rating: 5,
  },
  {
    id: 2,
    image: require("../assets/images/tadjiyev.jpg"),
    testimonieText:
      "Окааааа гап йук оёгимга колиптей тушди зур тураркпн оёкда. Юмшок, хам экан. Гап йук ока йенгил экан сифати хам зур ока. Барака топинг",
    avatar: require("../assets/images/266x286.png"),
    testimonieName: "Ш.И.Таджиев",
    indentity: "Mijoz",
    rating: 5,
  },
  {
    id: 3,
    image: require("../assets/images/nikeoq.jpg"),
    testimonieText:
      "Nike air force ni qabul qivoldim oka, sifati a'lo darajada, dostavkayam juda tez boldi, bunaqa kam kutaman dib oylamaganidim, Servizga gap yoq, TOP",
    avatar: require("../assets/images/266x286.png"),
    testimonieName: "Ibroxim",
    indentity: "Mijoz",
    rating: 5,
  },
];

const Testimonials = () => {
  const [imageSlider, setImageSlider] = useState();
  const [textSlider, setTextSlider] = useState();

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true
  };

  const renderStars = (rating) => {
    let stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <i 
          key={i} 
          className={i < rating ? "las la-star filled" : "las la-star"}>
        </i>
      );
    }
    return stars;
  };

  return (
    <section className="testimonials sp-t" id="testimonials">
      <Container>
        <Row>
          <Col lg={8} className="mx-auto text-center mb-5">
            {/* - Section Heading - */}
            <div className="section-heading">
              <div className="sub-heading">
                <p>Mijozlar Fikrlari</p>
              </div>
              <div className="heading-title">
                <h2>Mijozlarimiz Nima Deyishadi</h2>
              </div>
              <div className="heading-description">
                <p>Bizning poyabzallarimizni kiyib ko'rgan odamlarning taassurotlari</p>
              </div>
            </div>
            {/* - Section Heading - */}
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <div className="testimonials-box p-5">
              <Row className="align-items-center">
                <Col lg={5}>
                  {/* - Testimonial Image Slider - */}
                  <Slider
                    {...settings}
                    asNavFor={textSlider}
                    ref={(slider1) => setImageSlider(slider1)}
                    fade={true}
                    className="testimonie-thumb-slider"
                  >
                    {(testimonialsData || []).map((testimonie) => (
                      <div key={testimonie.id} className="testimonial-image-container">
                        <img
                          src={testimonie.image}
                          alt={testimonie.testimonieName}
                          className="testimonial-image"
                        />
                      </div>
                    ))}
                  </Slider>
                  {/* - Testimonial Image Slider - */}
                </Col>

                <Col lg={7} className="px-lg-5">
                  <div className="testie-quote">
                    <i className="las la-quote-left"></i>
                  </div>
                  {/* - Testimonial Text Slider - */}
                  <Slider
                    {...settings}
                    asNavFor={imageSlider}
                    ref={(slider2) => setTextSlider(slider2)}
                    className="testimonial-slider"
                    dots={true}
                    focusOnSelect={true}
                    adaptiveHeight={true}
                  >
                    {(testimonialsData || []).map((testimonie) => (
                      <div key={testimonie.id}>
                        <div className="testimonie-rating mb-3">
                          {renderStars(testimonie.rating)}
                        </div>
                        <div className="testimonie-text my-4">
                          "{testimonie.testimonieText}"
                        </div>
                        <div className="testimonie-meta d-flex align-items-center">
                          <div className="avatar">
                            <img
                              src={testimonie.avatar}
                              alt={testimonie.testimonieName}
                              className="rounded-circle"
                            />
                          </div>
                          <div className="info ms-4">
                            <strong>{testimonie.testimonieName}</strong>
                            <br />
                            <span>{testimonie.indentity}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                  {/* - Testimonial Text Slider - */}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Testimonials;
